<template>
  <div
    :id="id"
    class="element text date draggable"
    :class="[
      cssClasses,
      {
        selected: isSelected,
      },
    ]"
    :style="[basicStyles, transformStyles]"
  >
    <div
      class="text-wrap"
      :style="[textShadowStyles, /*textBackgroundStyles*/]"
      :class="[
        animationInStyle,
        animationOutStyle,
        'vertical-' + verticalAlign,
      ]">
      <transition
        :enter-active-class="'animated ' + animationIn"
        :leave-active-class="'animated ' + animationOut"
        :duration="{ leave: leaveDuration }"
        mode=""
        @after-enter="afterEnter"
        @before-leave="beforeLeave"
      >
        <div
          v-show="toggle"
          class="text-wrap date-wrap"
          :class="loopingClass"
          :style="[animationStyles]">
          {{ formattedDate }}
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { format as dateFormat } from 'date-fns';
import EventBus from '../../../utils/event-bus';
import ElementsMixins from '../../../mixins/elements-mixins';
import ResizeMixins from '../../../mixins/resize-mixins';
import MoveMixins from '../../../mixins/move-mixins';

export default {
  name: 'DateElement',
  mixins: [ElementsMixins, ResizeMixins, MoveMixins],
  data() {
    return {
      now: new Date(),
      timer: null,
    };
  },
  computed: {
    dataDate() {
      return (this.isMapped('text') && this.dataValue('text')) ?? false;
    },
    whichDate() {
      return this.dataDate || this.now;
    },
    formattedDate() {
      let offset;

      function stdTimezoneOffset(_date) {
        const jan = new Date(_date.getFullYear(), 0, 1);
        const jul = new Date(_date.getFullYear(), 6, 1);
        return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
      }

      function dst(_date) {
        return _date.getTimezoneOffset() < stdTimezoneOffset(_date);
      }

      if (!this.element.customTimeZone) {
        return dateFormat(
          new Date(this.whichDate),
          this.element.customFormat
            ? this.element.customFormatStyle
            : this.element.format,
        );
      }
      const date = new Date(this.whichDate);
      const localTime = date.getTime();
      const localOffset = date.getTimezoneOffset() * 60000;
      const utc = localTime + localOffset;
      offset = Number(this.element.customTimeZoneOffset);

      if (this.element.customTimeZoneHasDaylightSavings && dst(new Date())) {
        offset += 1;
      }

      const localTimestamp = utc + 3600000 * offset;

      return dateFormat(
        new Date(localTimestamp),
        this.element.customFormat
          ? this.element.customFormatStyle
          : this.element.format,
      );
    },
  },
  created() {
    if (!this.dataDate) {
      this.startDateTimer();
    }
  },
  mounted() {
    this.resizeText();
    EventBus.on('resize-text', this.resizeIfSelected);
    EventBus.on('draggable-resized', this.resizeIfSelected);
  },
  methods: {
    resizeIfSelected() {
      if (this.isSelected) this.resizeText();
    },
    edit() {},
    startDateTimer() {
      this.timer = setInterval(() => {
        this.now = new Date();
      }, 1000);
    },
    checkLines(text) {
      const $editor = $(this.$el).find('.date-wrap');
      const lines = Math.floor(
        $editor[0].offsetHeight / parseInt($editor.css('line-height'), 16),
      );
      const containsSingle = text.indexOf(' ') === -1;

      if (lines <= 1) {
        if (containsSingle) {
          $editor.css('word-wrap', 'break-word');
        } else {
          $editor.css('word-wrap', 'normal');
        }
      } else if (lines > 1) {
        if (containsSingle) {
          $editor.css('word-wrap', 'normal');
        } else {
          $editor.css('word-wrap', 'break-word');
        }
      }
    },
    resizeText() {
      const $this = $(this.$el);
      const $text = $this.find('.date-wrap');
      const maxFontSize = this.element.styles.fontSize;
      const minFontSize = 10; // Don't get smaller than this?
      let currentFontSize;

      if (!$text.length || !this.element.fitText) {
        $text.css('font-size', maxFontSize); // set it back to set font size
        return;
      }

      // Set word-wrap prior to calculating font size
      $text.css('word-wrap', 'normal');

      // Always start at max width and scale down from there
      $text.css('font-size', maxFontSize);
      let iterations = 0;

      while (
        $text[0].scrollHeight > $text[0].offsetHeight
        || $text[0].scrollWidth > $text[0].offsetWidth
      ) {
        if (iterations > 1000) {
          console.warn('Date resize infinite loop');
          break;
        }
        if (currentFontSize === minFontSize) {
          break;
        }

        currentFontSize = parseInt($text.css('font-size').replace('px', ''), 10);

        currentFontSize = Math.max(minFontSize, currentFontSize - 1);

        // Set new width
        $text.css('font-size', currentFontSize);
        iterations += 1;
      }

      // Check available lines of element and apply word-wrap rule
      this.checkLines(this.formattedDate);
    },
  },
  beforeUnmount() {
    clearInterval(this.timer);
    EventBus.off('resize-text', this.resizeIfSelected);
    EventBus.off('draggable-resized', this.resizeIfSelected);
  },
};
</script>
